import { schema } from "normalizr";
import { CarrierServiceWarehouseService as CarrierServiceWarehouseServiceRecord } from "records/shipping-accounts";

export const CarrierServiceWarehouseService = new schema.Entity(
    "accountCarrierServiceWarehouseService",
    {},
    {
        idAttribute: "id",
    }
);

(CarrierServiceWarehouseService as any).record = CarrierServiceWarehouseServiceRecord;
